import Vue from 'vue';
import qs from 'qs';

export default class ListUtils {
  static loadItemsData (instance, config) {
    instance.loaded = false;
    instance.loadError = false;
    let requestMethod = 'post';
    let parameters = config.params || {};

    if (config.method) {
      requestMethod = config.method;
    }

    if (config.method === 'get') {
      parameters = {
        params: parameters,
        paramsSerializer: params => qs.stringify(params)
      };
    }

    axios[requestMethod](config.endpoint, parameters)
    .then(response => {
      if (response.data.data) {
        instance[config.listField] = response.data.data;
      } else if (response.data[config.listField]) {
        instance[config.listField] = response.data[config.listField];
      }

      instance.loaded = true;

      if (config.pagination) {
        instance.paginationMetaData = response.data.meta || null;
      }

      if (config.successAction) {
        config.successAction(response.data);
      }
    }).catch(error => {
      console.log(error);
      instance.loaded = true;
      instance.loadError = true;
    });
  }

  static removeItem (instance, config) {
    let idFiledName = config.idFiledName ||  'id';

    Vue.swal({
      title: config.confirmTitle,
      html: config.confirmText,
      type: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Tak',
      cancelButtonText: 'Nie',
      buttonsStyling: true,
    }).then((result) => {
      if (result.value) {
        axios.post(config.endpointBase, { [idFiledName]: config.id })
        .then(response => {
          if (response.data.success) {
            Vue.swal({
              title: config.successTitle,
              html: config.successText,
              type: 'success',
              confirmButtonText: 'OK',
              showConfirmButton: true
            }).then(() => {
              config.successAction();
            }).catch((errors) => {
              console.log(errors);
              if (config.failAction) {
                config.failAction();
              }
            });
          } else {
            Vue.swal({
              title: config.errorTitle,
              html: config.errorText,
              type: 'warning',
              confirmButtonText: 'OK',
              showConfirmButton: true
            });
            if (config.failAction) {
              config.failAction();
            }
          }
        }).catch(error => {
          console.log(error);
          Vue.swal({
            title: config.errorTitle,
            html: config.errorText,
            type: 'warning',
            confirmButtonText: 'OK',
            showConfirmButton: true,
            buttonsStyling: true
          });
          if (config.failAction) {
            config.failAction();
          }
        });
      } else {
        if (config.cancelAction) {
          config.cancelAction();
        }
      }
    });
  }
}
